"use client";

import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { HeartPulse, Activity, Brain, Baby, Stethoscope, ChevronRight, CircleCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const specialties = [{
  id: "clinica-geral",
  title: "CLÍNICA GERAL",
  description: "Cuidados de saúde primários e acompanhamento global e preventivo para toda a família.",
  icon: "Activity",
  image: "",
  isLarge: true
}, {
  id: "medicina-dentaria",
  title: "MEDICINA DENTÁRIA",
  description: "Serviços especializados em saúde oral, estética e tratamentos restauradores avançados.",
  icon: "Activity",
  image: "",
  isLarge: false
}, {
  id: "analises-clinicas",
  title: "ANÁLISES CLÍNICAS",
  description: "Exames laboratoriais precisos para diagnóstico e monitorização constante do seu estado de saúde.",
  icon: "Activity",
  image: "",
  isLarge: false
}, {
  id: "neurologia",
  title: "NEUROLOGIA",
  description: "Diagnóstico e tratamento de patologias do sistema nervoso central e periférico.",
  icon: "Activity",
  image: "",
  isLarge: false
}, {
  id: "ginecologia",
  title: "GINECOLOGIA",
  description: "Acompanhamento especializado da saúde da mulher em todas as etapas do ciclo de vida.",
  icon: "Activity",
  image: "",
  isLarge: false
}, {
  id: "urologia",
  title: "UROLOGIA",
  description: "Tratamento de doenças do sistema urinário e do aparelho reprodutor masculino.",
  icon: "Activity",
  image: "",
  isLarge: false
}, {
  id: "endocrinologia",
  title: "ENDOCRINOLOGIA",
  description: "Especialidade focada no sistema endócrino, metabolismo e distúrbios hormonais.",
  icon: "Activity",
  image: "",
  isLarge: false
}, {
  id: "otorrinolaringologia",
  title: "OTORRINOLARINGOLOGIA",
  description: "Cuidados médicos e cirúrgicos relacionados com ouvidos, nariz e garganta.",
  icon: "Activity",
  image: "",
  isLarge: false
}, {
  id: "oftalmologia",
  title: "OFTALMOLOGIA",
  description: "Prevenção, diagnóstico e tratamento de patologias oculares e da visão.",
  icon: "Activity",
  image: "",
  isLarge: false
}, {
  id: "dermatologia",
  title: "DERMATOLOGIA",
  description: "Tratamento de doenças da pele, cabelo e unhas, aliando saúde e estética.",
  icon: "Activity",
  image: "",
  isLarge: false
}, {
  id: "psiquiatria",
  title: "PSIQUIATRIA",
  description: "Avaliação e tratamento de transtornos mentais, promovendo o equilíbrio emocional.",
  icon: "Activity",
  image: "",
  isLarge: false
}, {
  id: "psicologia",
  title: "PSICOLOGIA",
  description: "Apoio psicológico e psicoterapia para o desenvolvimento do bem-estar mental.",
  icon: "Activity",
  image: "",
  isLarge: false
}, {
  id: "terapia-da-fala",
  title: "TERAPIA DA FALA",
  description: "Reabilitação de distúrbios da comunicação, linguagem, fala e deglutição.",
  icon: "Activity",
  image: "",
  isLarge: false
}, {
  id: "nutricao",
  title: "NUTRIÇÃO",
  description: "Aconselhamento alimentar personalizado para uma vida mais saudável e equilibrada.",
  icon: "Activity",
  image: "",
  isLarge: false
}, {
  id: "podologia",
  title: "PODOLOGIA",
  description: "Especialidade dedicada ao estudo, diagnóstico e tratamento dos pés.",
  icon: "Activity",
  image: "",
  isLarge: false
}, {
  id: "acupuntura",
  title: "ACUPUNTURA",
  description: "Terapia complementar baseada na medicina tradicional chinesa para alívio de sintomas.",
  icon: "Activity",
  image: "",
  isLarge: false
}, {
  id: "cirurgia-geral",
  title: "CIRURGIA GERAL",
  description: "Intervenções cirúrgicas diversificadas com foco na recuperação rápida do paciente.",
  icon: "Activity",
  image: "",
  isLarge: false
}, {
  id: "neurocirurgia",
  title: "NEUROCIRURGIA",
  description: "Tratamento cirúrgico de doenças complexas do cérebro e da coluna vertebral.",
  icon: "Activity",
  image: "",
  isLarge: false
}, {
  id: "enfermagem",
  title: "ENFERMAGEM",
  description: "Cuidados diretos de saúde, pensos, vacinação e acompanhamento contínuo.",
  icon: "Activity",
  image: "",
  isLarge: false
}];
const subServices = [];
const renderIcon = (iconName: string, className: string) => {
  switch (iconName) {
    case "HeartPulse":
      return <HeartPulse className={className} />;
    case "Activity":
      return <Activity className={className} />;
    case "Brain":
      return <Brain className={className} />;
    case "Baby":
      return <Baby className={className} />;
    case "Stethoscope":
      return <Stethoscope className={className} />;
    default:
      return <Activity className={className} />;
  }
};
export default function MedicalSpecialties() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="90449" id="as-nossas-especialidades" className="py-20 bg-background overflow-hidden" ref={ref}>
      <div className="container mx-auto px-4 md:px-6">
        <div className={`flex flex-col md:flex-row md:items-end justify-between mb-12 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="max-w-2xl">
            <h2 className="text-sm font-bold tracking-wider text-secondary uppercase mb-3">
              Excelência Médica
            </h2>
            <h3 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary tracking-tight">
              As Nossas Especialidades
            </h3>
            <p className="mt-4 text-muted-foreground text-lg">
              Oferecemos uma vasta gama de especialidades médicas para atender a todas as suas necessidades de saúde com rigor e dedicação.
            </p>
          </div>
          
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6 auto-rows-[280px]">
          {specialties.map((specialty, index) => {
          const specialtySubServices = subServices.filter(sub => sub.specialtyId === specialty.id);
          if (specialty.isLarge) {
            return <div key={specialty.id} data-index={index} className={`group relative overflow-hidden rounded-2xl md:col-span-2 md:row-span-2 flex flex-col justify-end p-8 shadow-lg transition-all duration-700 ease-out delay-[${index * 100}ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                  <div className="absolute inset-0 bg-cover bg-center transition-transform duration-1000 group-hover:scale-105" style={{
                backgroundImage: `url(${specialty.image})`
              }} />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary/95 via-primary/60 to-primary/10 transition-opacity duration-500 group-hover:opacity-90" />
                  
                  <div className="relative z-10 text-primary-foreground flex flex-col h-full justify-end">
                    <div className="mb-auto flex justify-end">
                       <div className="bg-background/20 backdrop-blur-md p-3 rounded-full">
                          {renderIcon(specialty.icon, "size-8 text-secondary")}
                       </div>
                    </div>
                    
                    <div>
                      <h4 className="text-3xl md:text-4xl font-bold mb-3 text-primary-foreground">
                        {specialty.title}
                      </h4>
                      
                      <div className="relative overflow-hidden">
                        <p className="text-primary-foreground/80 text-lg transition-all duration-500 ease-in-out transform origin-top">
                          {specialty.description}
                        </p>
                        
                        <div className="absolute top-0 left-0 w-full opacity-0 translate-y-8 transition-all duration-500 ease-in-out group-hover:opacity-100 group-hover:translate-y-0 group-hover:relative">
                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                            {specialtySubServices.map((sub, subIndex) => <div key={sub.id} data-index={subIndex} className="flex items-center gap-2 text-primary-foreground/90">
                                <CircleCheck className="size-4 text-secondary shrink-0" />
                                <span className="text-sm font-medium">{sub.name}</span>
                              </div>)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>;
          }
          return <Card key={specialty.id} data-index={index} className={`group h-full flex flex-col justify-between transition-all duration-500 hover:shadow-xl hover:bg-accent hover:border-secondary/40 hover:-translate-y-1 bg-card border-border/50 ease-out delay-[${index * 100}ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                <CardHeader className="pb-4">
                  <div className="bg-muted/50 w-14 h-14 rounded-xl flex items-center justify-center mb-4 transition-colors duration-300 group-hover:bg-secondary/10">
                    {renderIcon(specialty.icon, "size-7 text-secondary transition-transform duration-500 group-hover:scale-110")}
                  </div>
                  <CardTitle className="text-xl text-primary transition-colors">
                    {specialty.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow flex flex-col justify-end relative overflow-hidden">
                  <p className="text-muted-foreground text-sm transition-all duration-300 absolute inset-x-6 bottom-6">
                    {specialty.description}
                  </p>
                  
                  <div className="opacity-0 translate-y-8 transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0">
                    <ul className="space-y-2">
                      {specialtySubServices.slice(0, 3).map((sub, subIndex) => <li key={sub.id} data-index={subIndex} className="flex items-start gap-2 text-sm text-muted-foreground">
                          <ChevronRight className="size-4 text-secondary shrink-0 mt-0.5" />
                          <span>{sub.name}</span>
                        </li>)}
                    </ul>
                  </div>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}